var __WEBPACK_NAMESPACE_OBJECT__ = require("formiojs/components/tabs/Tabs.form");